<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <ManListeFss :fss=fss></ManListeFss>
      </div>
    </div>
  </div>
</template>

<script>
import ManListeFss from '@/components/ManListeFss.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: [],
  }},

  name: 'ManStatut',
  components: {
    ManListeFss,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/man/hsp_list.php',
          { })
        .then(response => (this.fss = response.data))
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
